import React, { useEffect, useState } from 'react';
import { getNeonAccessTokenOrRedirect } from '../authHelpers/authHelpers';
import API_BASE_URL from '../api';

export default function DebugMe() {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchMe() {
      try {
        const { accessToken } = await getNeonAccessTokenOrRedirect();

        const res = await fetch(`${API_BASE_URL}/api/me`, {
          headers: {
            'Content-Type': 'application/json',
            'x-stack-access-token': accessToken, // 👈 matches backend middleware
          },
        });

        const json = await res.json();
        setData(json);
      } catch (err) {
        console.error('Error calling /api/me:', err);
      }
    }

    fetchMe();
  }, []);

  return (
    <pre style={{ color: 'white' }}>
      {data ? JSON.stringify(data, null, 2) : 'Loading /api/me...'}
    </pre>
  );
}
